import styled from 'styled-components';

export const Container = styled.div`
	width: 100vw;
	min-width: 1400px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 110px;
`;
